// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { autoDeliveryModalStyles } from "@guestsupply/App/Components/Product/AutoDeliveryModal";
import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { color, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

autoDeliveryModalStyles.managedAccordionSectionStyle = {
    headerProps: {
        css: css`
            ${TypographyStyle} {
                height: 16px;
                font-size: 14px;
                font-weight: bold;
                line-height: 16px;
            }
            button,
            button:focus {
                padding-top: 12px;
                &[aria-expanded="true"] {
                    padding-bottom: 4px;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            margin: 0;
            display: flex;
            padding-bottom: 0;
            margin-bottom: 12px;
            &&&[hidden] {
                display: none;
            }
            ${xScreen("lte", "md")} {
                flex-direction: column;
            }
        `,
    },
};
autoDeliveryModalStyles.productListContainerStyles = {
    container: {
        css: css`
            border: none;
            padding: 0;
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                & > .top-section {
                    width: 100%;
                    height: 100%;
                }
            }

            & > .middle-section {
                flex: 1;
                margin: 0;
                padding: 0 24px 0 12px;
                ${xScreen("lte", "sm")} {
                    padding: 0;
                }
            }
            & > .bottom-section {
                margin-top: 0;
                display: flex;
                flex-direction: column;
                gap: 12px;
            }
        `,
    },
    image: {
        css: css`
            width: 113px;
            height: max-content;
            max-height: 143px;
            overflow: hidden;
            margin: 0;
            ${xScreen("lte", "md")} {
                width: 75px;
                max-height: 113px;
                padding-bottom: 5px;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
                height: 100%;
                padding-bottom: 10px;
                max-height: unset;
            }
        `,
    },
    priceAndActions: {
        css: css`
            margin-top: 0;
            gap: 8px;
            padding-left: 24px;
            border-left: 1px solid ${getColor("common.border")};
        `,
    },
    info: {
        css: css`
            height: 100%;
            justify-content: space-between;
            gap: 0;
        `,
    },
};
autoDeliveryModalStyles.orderSummaryGridContainer = {
    ...cartSummarySharedStyles.container,
};
autoDeliveryModalStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
autoDeliveryModalStyles.titleText = {
    ...cartSummarySharedStyles.titleText,
};
autoDeliveryModalStyles.labelGridItem = {
    ...cartSummarySharedStyles.labelGridItem,
};
autoDeliveryModalStyles.labelText = {
    ...cartSummarySharedStyles.labelText,
};
autoDeliveryModalStyles.valueGridItem = {
    ...cartSummarySharedStyles.valueGridItem,
};
autoDeliveryModalStyles.totalValue = {
    ...cartSummarySharedStyles.totalValue,
};
autoDeliveryModalStyles.valueText = {
    ...cartSummarySharedStyles.valueText,
};
autoDeliveryModalStyles.totalLabel = {
    ...cartSummarySharedStyles.totalLabel,
};
autoDeliveryModalStyles.dividerGridItem = {
    ...cartSummarySharedStyles.dividerGridItem,
};
autoDeliveryModalStyles.AdditionalInfoGridItem = {
    ...cartSummarySharedStyles.AdditionalInfoGridItem,
};
autoDeliveryModalStyles.AdditionalInfoText = {
    ...cartSummarySharedStyles.AdditionalInfoText,
};
autoDeliveryModalStyles.accordionWrapperStyle = {
    css: css`
        display: flex;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
autoDeliveryModalStyles.accordionStyle = {
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        width: calc(100% - 342px);
        height: fit-content;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
autoDeliveryModalStyles.shiptoText = {
    css: css`
        max-width: 240px;
        ${xScreen("lte", "md")} {
            max-width: initial;
        }
    `,
};
autoDeliveryModalStyles.productActionsWrapper = {
    css: css`
        display: flex;
        gap: 22px;
        align-items: center;
        margin-top: 8px;
        ${xScreen("lte", "sm")} {
            margin-top: 12px;
        }
    `,
};
autoDeliveryModalStyles.deliveryScheduleWrapper = {
    css: css`
        display: flex;
        gap: 22px;
        flex: 1;
        > div {
            flex: 1;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 16px;
            > div {
                width: 100%;
            }
        }
    `,
};
autoDeliveryModalStyles.creationDateStyle = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        datePicker: css`
            .react-datetime-picker__inputGroup__year {
                width: calc(100% - 75px) !important;
            }
        `,
    },
};
autoDeliveryModalStyles.orderSummaryWrapper = {
    css: css`
        width: 320px;
        max-width: 320px;
        margin-left: 22px;
        ${xScreen("lte", "sm")} {
            margin-left: 0;
            width: 100%;
            max-width: initial;
            margin-top: 16px;
        }
    `,
};
autoDeliveryModalStyles.submitButton = {
    css: css`
        width: 100%;
        margin: 0 9px 8px;
    `,
};
autoDeliveryModalStyles.productActionsStyle = {
    addToCartContainer: {
        css: css`
            min-width: 88px;
            max-width: 88px;
        `,
    },
};
autoDeliveryModalStyles.tooltipContainer = {
    cssOverrides: {
        tooltipWrapper: css`
            [role="link"] {
                vertical-align: top;
                margin: 0;
            }
        `,
    },
};
autoDeliveryModalStyles.tooltipWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        ${IconWrapper} {
            color: ${color("primary", 0.33)};
        }
        &:hover {
            ${IconWrapper} {
                color: ${color("primary")};
            }
        }
    `,
};
autoDeliveryModalStyles.notify = {
    css: css`
        margin: 12px 0 0 0;
    `,
};
autoDeliveryModalStyles.productImage = {
    productImage: {
        badgeWrapper: {
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
    },
};
autoDeliveryModalStyles.modal = {
    cssOverrides: {
        modalTitle: css`
            border: none;
            &&& {
                padding: 20px 20px 16px;
            }
        `,
        modalContent: css`
            &&& {
                padding: 0 20px 20px;
            }
        `,
    },
};
